export enum UIAnalyticsEventKey {
  LOG_IN = 'Log in',
  LOG_OUT = 'Log out',
  TENANT_SWITCH = 'Tenant switch',
  URL_CHANGED = 'URL changed',
}
